// shared-types/src/accountPaymentMethod/resolveChargeCurrency.ts
import { Currency } from '../common/Currency'

function normalizedAccountCurrency(accountCurrency?: string | null): Currency | undefined {
    const t = accountCurrency?.trim()
    if (!t) return undefined
    return t as Currency
}

/**
 * Currency in which the payment gateway will settle the charge for checkout.
 * Centralizes provider-specific rules; consumers (e.g. storefront) should use
 * {@link AccountPaymentMethod.chargeCurrency} from the API instead of branching on providerKey.
 */
export function resolveChargeCurrency(params: {
    providerKey?: string | null
    settingsCurrency?: string | null
    /** Store / account currency; used when settings omit currency or for MANUAL_PAYMENT. */
    accountCurrency?: string | null
}): Currency | undefined {
    const pk = params.providerKey?.toUpperCase()
    if (pk === 'PAYPAL') {
        return Currency.USD
    }
    const accountCur = normalizedAccountCurrency(params.accountCurrency)
    if (pk === 'MANUAL_PAYMENT') {
        return accountCur
    }
    const raw = params.settingsCurrency?.trim()
    if (!raw) {
        return accountCur
    }
    return raw as Currency
}
